import { CONTENT_WIDTH_MID_CENTERED_2_COLUMN } from '@sleepstation/metrics-public-site'
import {
  backgroundImageLinearGradient,
  padding,
  mq,
  stylesIfPropTrue,
} from '@sleepstation/style-api-helpers'
import { constrain } from '@sleepstation/style-mixins'
import {
  defaultTheme,
  reversedAltTheme,
} from '@sleepstation/themes-public-site'
import PropTypes from 'prop-types'
import React from 'react'
import styled, { ThemeProvider, css } from 'styled-components'
import Border from '../../Border'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  overflow: hidden;
  border-top: 1px solid white;
  ${padding([[1, 0, 1.33]])}

  ${backgroundImageLinearGradient()}

  ${stylesIfPropTrue(
    `showAtXSmallOnly`,
    css`
      ${mq(`smallUp`)} {
        display: none;
      }
    `
  )}
`

const Image = styled.div`
  position: absolute;
  inset: 0;
  background-position: top center;
  background-repeat: no-repeat;
  z-index: 1;
`

const Content = styled.div`
  position: relative;
  z-index: 2;
  color: white;
  ${constrain(CONTENT_WIDTH_MID_CENTERED_2_COLUMN)}
`

const Inner = styled.div`
  overflow: hidden;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HeaderAttachedBreakoutModule = ({
  children,
  showAtXSmallOnly,
  showBottomBorder,
}) => (
  <ThemeProvider theme={reversedAltTheme}>
    <Layout
      showAtXSmallOnly={showAtXSmallOnly}
      showBottomBorder={showBottomBorder}
      className="Breakout"
    >
      <Inner>
        <ThemeProvider theme={defaultTheme}>
          {showBottomBorder && (
            <Border edge="bottom" kind="inset" color="backgroundStart" />
          )}
        </ThemeProvider>
        <Image />
        <Content>{children}</Content>
      </Inner>
    </Layout>
  </ThemeProvider>
)

HeaderAttachedBreakoutModule.propTypes = {
  children: PropTypes.node.isRequired,
  showAtXSmallOnly: PropTypes.bool,
  showBottomBorder: PropTypes.bool,
}

HeaderAttachedBreakoutModule.defaultProps = {
  showAtXSmallOnly: false,
  showBottomBorder: true,
}

export default HeaderAttachedBreakoutModule
